import React, { useContext, useEffect, useState } from "react"
import { UserTypeContext } from "./context/userStatus";
import { userService } from "./services/auth";
import PaymentPlanInfo, { PAYMENT_STATUS } from "./view/trackerNewV2/paymentplaninfo";
import { setAccountBlocked, setUserObject } from "./store/actions/userTypeAction";

const CheckAndBlockPayments = () => {
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    let userValues = JSON.parse(localStorage.getItem("userValues"));
    const [userDetailsLoaded, setUserDetailsLoaded] = useState(false);
    const [visiblePaymentFree, setVisiblePaymentFree] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState(PAYMENT_STATUS.ONBOARD);
    const [subscriptionPlanEnded, setSubscriptionPlanEnded] = useState(false);
    const [subscriptionPlanEndedBilling, setSubscriptionPlanEndedBilling] = useState(false);
    useEffect(() => {
        getUserDetails()
    }, [])
    const getUserDetails = () => {
        const userId = {
            uid: IUserTypeState?.userId ? IUserTypeState?.userId : userValues?.uid,
        };
        userService
            .getUserById(userId)
            .then((data: any) => {
                setUserDetailsLoaded(true);
                userTypeDispatch(
                    setUserObject({
                        ...data?.data,
                        showGoal: data?.showGoal,
                        userSubscriptionStatus: data.userSubscriptionStatus,
                        userAccountStatus: data?.userAccountStatus,
                        celebrationData: data?.celebrationData,
                        formatHolidayEndDate: data?.formatHolidayEndDate,
                        formatHolidayStartDate: data?.formatHolidayStartDate,
                        holidayMode: data?.holidayMode
                    })
                );
                localStorage.setItem("userValues", JSON.stringify(data?.data));
                if (data.data.paymentPopup15Days && data.data.paymentPopup15Days === "VISIBLE") {
                    setPaymentStatus(PAYMENT_STATUS.FREE_COMPLETED_V3)
                    setVisiblePaymentFree(true)
                    return
                }
                if (["FREE_PLAN_END"].includes(data.userSubscriptionStatus)) {
                    setPaymentStatus(PAYMENT_STATUS.FREE_COMPLETED_V2)
                    setVisiblePaymentFree(true)
                }
                if (["30_DAYS_RECOVER"].includes(data.userSubscriptionStatus)) {
                    setPaymentStatus(PAYMENT_STATUS.ACCOUNT_BLOCKED)
                    setVisiblePaymentFree(false)
                    userTypeDispatch(setAccountBlocked(true))
                }
                if (["SUBSCRIPTION_END"].includes(data.userSubscriptionStatus)) {
                    setPaymentStatus(PAYMENT_STATUS.SUBSCRIPTION_ENDED)
                    setVisiblePaymentFree(true)
                }
            })
            .catch((error) => {
                console.log("User profile Error");
            });
    };

    return userDetailsLoaded && visiblePaymentFree && !IUserTypeState.hasSeenGlobalModal &&
        <PaymentPlanInfo
            visiblePaymentInfo={visiblePaymentFree}
            onClose={() => {
                if (!subscriptionPlanEnded) {
                    localStorage.removeItem("showPayment")
                    setVisiblePaymentFree(false)
                }
            }}
            closeAndOpenRestriction={() => {
                if (["30_DAYS_RECOVER"].includes(IUserTypeState.userDetails?.userSubscriptionStatus)) {
                    setPaymentStatus(PAYMENT_STATUS.ACCOUNT_BLOCKED)
                    setVisiblePaymentFree(false)
                    userTypeDispatch(setAccountBlocked(true))
                } else {
                    setPaymentStatus(PAYMENT_STATUS.FREE_COMPLETED_V2)
                    setVisiblePaymentFree(true)
                }
            }}
            subscriptionPlanEndedBilling={subscriptionPlanEndedBilling}
            subscriptionPlanEnded={subscriptionPlanEnded}
            paymentStatus={paymentStatus}
        />
}

export default CheckAndBlockPayments